<div>
	<div class="header">
		<div class="title" *ngIf="title">
			<h3>{{title}}</h3>
		</div>
		<div style="display: flex;">
			<form [formGroup]="inputDateForm" style="display: flex;">
				<mat-form-field appearance="outline" class="table-filter" appearance="outline"
					style="margin-right: 15px; ">
					<mat-label>Choose a date</mat-label>
					<input matInput [matDatepicker]="picker" formControlName="input_date">
					<mat-hint>MM/DD/YYYY</mat-hint>
					<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
				</mat-form-field>
				<button mat-raised-button color="primary" (click)="getBalance()">Submit</button>
			</form>
		</div>
	</div>
	<div>
		<table class="styled-table">
			<caption>Loan Staging</caption>
			<thead>
				<tr>
					<th>&nbsp;</th>
					<th>Low Risk</th>
					<th>Normal Risk</th>
					<th>High Risk</th>
					<th>Total</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Stage 1</td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/1/low">{{currencyFormatter.transform(balance.stage1.low, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/1/normal">{{currencyFormatter.transform(balance.stage1.normal, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td>-</td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/1/all">{{currencyFormatter.transform(balance.stage1.total, 'CAD', 'symbol-narrow')}}</a></div></td>
				</tr>
				<tr>
					<td>Stage 2</td>
					<td>-</td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/2/normal">{{currencyFormatter.transform(balance.stage2.normal, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/2/high">{{currencyFormatter.transform(balance.stage2.high, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/2/all">{{currencyFormatter.transform(balance.stage2.total, 'CAD', 'symbol-narrow')}}</a></div></td>
				</tr>
				<tr>
					<td>Stage 3</td>
					<td>-</td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/3/normal">{{currencyFormatter.transform(balance.stage3.normal, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/3/high">{{currencyFormatter.transform(balance.stage3.high, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/3/all">{{currencyFormatter.transform(balance.stage3.total, 'CAD', 'symbol-narrow')}}</a></div></td>
				</tr>
				<tr>
					<td>Total</td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/all/low">{{currencyFormatter.transform(balance.low, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/all/normal">{{currencyFormatter.transform(balance.normal, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/all/high">{{currencyFormatter.transform(balance.high, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td class="total"><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/all/all">{{currencyFormatter.transform(balance.total, 'CAD', 'symbol-narrow')}}</a></div></td>
				</tr>
			</tbody>
		</table>

		<table class="styled-table">
			<caption>ECL for Loan Staging</caption>
			<thead>
				<tr>
					<th>&nbsp;</th>
					<th>Low Risk</th>
					<th>Normal Risk</th>
					<th>High Risk</th>
					<th>Total</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Stage 1</td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/1/low">{{currencyFormatter.transform(eclBalance.stage1.low, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/1/normal">{{currencyFormatter.transform(eclBalance.stage1.normal, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td>-</td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/1/all">{{currencyFormatter.transform(eclBalance.stage1.total, 'CAD', 'symbol-narrow')}}</a></div></td>
				</tr>
				<tr>
					<td>Stage 2</td>
					<td>-</td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/2/normal">{{currencyFormatter.transform(eclBalance.stage2.normal, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/2/high">{{currencyFormatter.transform(eclBalance.stage2.high, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/2/all">{{currencyFormatter.transform(eclBalance.stage2.total, 'CAD', 'symbol-narrow')}}</a></div></td>
				</tr>
				<tr>
					<td>Stage 3</td>
					<td>-</td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/3/normal">{{currencyFormatter.transform(eclBalance.stage3.normal, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/3/high">{{currencyFormatter.transform(eclBalance.stage3.high, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/3/all">{{currencyFormatter.transform(eclBalance.stage3.total, 'CAD', 'symbol-narrow')}}</a></div></td>
				</tr>
				<tr>
					<td>Total</td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/all/low">{{currencyFormatter.transform(eclBalance.low, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/all/normal">{{currencyFormatter.transform(eclBalance.normal, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/all/high">{{currencyFormatter.transform(eclBalance.high, 'CAD', 'symbol-narrow')}}</a></div></td>
					<td class="total"><div *ngIf="!isLoading; else skeleton"><a href="admin-reports/loans/{{inputDateForm.controls.input_date.value.toISOString().substring(0, 10)}}/all/all">{{currencyFormatter.transform(eclBalance.total, 'CAD', 'symbol-narrow')}}</a></div></td>
				</tr>
			</tbody>
		</table>
	</div>

	<!-- Reusable Skeleton Templates -->
	<ng-template #skeleton>
		<ngx-skeleton-loader count="1" appearance="line"
			[theme]="{ height: '20px', width: '140px', margin: '0' }"></ngx-skeleton-loader>
	</ng-template>
</div>